import cx from 'classnames';
import { intcomma } from 'journalize';
import { h, VNode } from 'preact';

import PureComponent from './PureComponent';

import winnerClass from '../utils/winner-class';
import AnimatedNumber from './AnimatedNumber';
import PctChange from './PctChange';
import PartyPill from './PartyPill';
import VoteBar from './VoteBar';

interface Props {
  ballotName: string;
  candidateId: string;
  contestIsCalled: boolean;
  contestResult: string;
  isIncumbent: boolean;
  isWinner: boolean;
  candidateColors: { [key: string]: any };
  party: string;
  totalVotesInContest: number;
  votes: number;
}

const formatVotes = (n: number) => intcomma(Math.round(n));
const formatPct = (n: number) => n.toFixed(1);
const pctValue = (votes: number, total: number) =>
  total == null || total <= 0 ? 0 : (votes / total) * 100;

class HeadshotCandidateRow extends PureComponent<Props> {
  static columnCount: number;
  static Header: VNode;

  render() {
    const {
      ballotName,
      candidateId,
      contestIsCalled,
      contestResult,
      isIncumbent,
      isWinner,
      party,
      isViewable,
      totalVotesInContest,
      candidateColors,
      votes,
    } = this.props;

    let getColor;

    if (candidateColors) {
      getColor = candidateColors
        .filter(obj => obj.name == ballotName)
        .map(obj => obj.color);
    } else {
      getColor = ['#777777'];
    }

    const divStyle = {
      'background-color': getColor[0],
    };

    const checkStyle = {
      color: getColor[0],
    };

    const IsAsterisk = ballotName == 'Rick Perry' ? true : false;

    let rowClass = cx(
      'candidate',
      'contest__candidate-row',
      'contest__candidate-row--headshot',
      {
        'contest__candidate-row--winner dem--border':
          contestIsCalled && isWinner && party == 'Democrat',
        'contest__candidate-row--winner rep--border':
          contestIsCalled && isWinner && party == 'Republican',
      }
    );

    const checkClass = cx('check', winnerClass(party, contestResult));

    if (!isViewable) {
      rowClass += ' race__candidate-row--hidden';
    }

    const checkmark = '\u2713';

    return (
      <tr class={rowClass}>
        <td class="candidate__cell candidate__party">
            <PartyPill party={party} style={divStyle} />
        </td>
        <th class="candidate__cell candidate__name">
          <span class="candidate__name-line">
            {contestIsCalled && isWinner && contestResult != 'runoff' && (
              <span class={checkClass} style={checkStyle}>
                {checkmark}
              </span>
            )}
            {contestIsCalled && isWinner && contestResult == 'runoff' && (
              <span class={checkClass}>{checkmark}</span>
            )}
            {contestIsCalled && isWinner && contestResult != 'runoff' ? (
              <span class={checkClass}>{ballotName}</span>
            ) : (
              ballotName
            )}
            {IsAsterisk && <span class="asterisk">*</span>}{' '}
            {isIncumbent && (
              <span class="pill pill--basic" title="Currently holds this seat">
                Incumbent
              </span>
            )}
          </span>
          <VoteBar
            value={pctValue(votes, totalVotesInContest)}
            party={party}
            color={getColor[0]}
          />
        </th>
        <td class="candidate__cell candidate__votes"><AnimatedNumber value={votes} format={formatVotes} /></td>
        <td class="candidate__cell candidate__pct">
          <PctChange value={pctValue(votes, totalVotesInContest)} party={party} />
          <AnimatedNumber
            value={pctValue(votes, totalVotesInContest)}
            format={formatPct}
            odometerFormat="(,ddd).d"
          />
          <span class="candidate__pct-symbol">%</span>
        </td>
      </tr>
    );
  }
}

HeadshotCandidateRow.defaultProps = {
  isIncumbent: false,
  isCalled: false,
  isWinner: false,
  isViewable: true,
};

HeadshotCandidateRow.Header = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

HeadshotCandidateRow.columnCount = 6;

export default HeadshotCandidateRow;